var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"is-flex is-justify-content-center"},[_c('p',[_vm._v("Sistema de registro de incidentes SOLEM 2024")])])
}]

export { render, staticRenderFns }